<template>
  <header :class="[noBottomLine?'header-no-bottom-line':'']">
    <div class="left">
      <img src="../image/iconLeftBack@3x.png" width="11px" height="19px" alt v-show="showBack" @click="goBack" />
    </div>
    <div class="title">
      <slot name="title">{{routerTitle}}</slot>
    </div>
    <div class="right">
      <slot name="right"></slot>
    </div>
  </header>
</template>
<script>
import icon from './icon'
import CONSTANT from '../constant'
export default {
  name: 'my-header',
  props: {
    isToggle: {
      type: Boolean,
      default: false,
    },
    showBack: {
      type: Boolean,
      default: false,
    },
    noBottomLine: {
      type: Boolean,
      default: false,
    },
    onBack: {
      type: Function,
      default: null,
    },
  },
  computed: {
    routerTitle() {
      const self = this
      let title = ''
      this.$router.options.routes.forEach(el => {
        ;(function loopChild(child) {
          if (child.name === self.$route.name) {
            return (title = child.title)
          }
          if (!child.children) {
            return
          }
          child.children.forEach(loopChild)
        })(el)
      })
      return title
    },
  },
  components: {
    icon,
  },
  methods: {
    onHomeClick() {
      this.$router.push('/')
    },
    goBack() {
      // 自定义返回处理回调事件
      if (this.onBack && typeof this.onBack === 'function') {
        return this.onBack()
      }

      if (document.referrer.match(CONSTANT.COOKIE_DEFAULT_DOMAIN)) {
        return this.$router.go(-1)
      }
      // if (window.history.length == 2) {
      //   return this.onHomeClick()
      // }
      history.back()
    },
  },
}
</script>
<style lang="less" scoped>
@import '../style/variable';

@inkGrey: rgb(46, 47, 48);
header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: @headerHeight;
  overflow: hidden;
  margin: 0;
  padding: 0;
  z-index: 300;
  background-color: #ffffff;
  & > div {
    float: left;
    height: @headerHeight;
  }
  &::after {
    .setBottomLine();
  }
  i {
    display: block;
    font-size: 23px;
    color: @inkGrey;
  }
  .left {
    width: 17%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    & > i {
      margin-left: 10px;
    }
    & > img {
      margin-left: 14px;
      vertical-align: middle;
    }
  }
  .title {
    width: 66%;
    text-align: center;
    font-size: 17px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: @inkGrey;
    div {
      color: @inkGrey;
    }
  }
  .right {
    width: 17%;
    display: flex;
    justify-content: center;
    align-items: center;
    div {
      width: 100%;
      text-align: center;
    }
  }
}
.header-no-bottom-line {
  &::after {
    display: none;
  }
}
</style>
